<template>
  <div class="product-students-import-modal p-5">
    <h5>Importar alunos</h5>
    <small>
      Caso não deseje escolher uma turma agora, os alunos serão importados ao
      curso sem turma definida. Você poderá definir isso depois, manualmente, um
      aluno por vez.
    </small>

    <form-group
      select
      id="select-group"
      v-model="form.group_id"
      class="mt-3 pb-0"
      placeholder="Selecionar turma"
      :options="[{ id: '', name: 'Nenhuma turma' }, ...groups]"
      label="Turma"
    />
    <small>
      Todos os alunos importados no arquivo CSV serão alocados para a turma
      selecionada.
    </small>

    <div v-if="lastImportStatus" class="alert my-6" :class="alertClass">
      <i :class="alertIcon"></i>
      Última importação {{ alertMsg }}
    </div>

    <input-file v-model="form.file" title="Arquivo CSV" />

    <p class="small text-secondary">
      Campos separados por vírgula nesta ordem: Nome, e-mail, telefone e data de
      expiração.
      <a href="/alunos-exemplo.csv" target="_blank">Baixar modelo</a>
    </p>

    <div class="d-flex justify-content-end mx-n3">
      <button class="btn btn-secondary px-9 mx-3 my-3" @click="$emit('close')">
        Cancelar
      </button>
      <button
        class="btn btn-primary px-9 mx-3 my-3"
        @click="submit"
        :disabled="!form.file"
      >
        <loading :show="loading">
          Importar
        </loading>
      </button>
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  data() {
    return {
      lastImportStatus: null,
      ...formFields(["file", "product_id", "group_id"], {
        product_id: this.$route.params.id
      })
    };
  },
  computed: {
    ...mapState("membersGroups", ["groups"]),
    alertClass() {
      return {
        success: "alert-success",
        fail: "alert-danger",
        in_progress: "alert-warning"
      }[this.lastImportStatus];
    },
    alertIcon() {
      return {
        success: "icon-check",
        fail: "icon-exclamation-outline",
        in_progress: "icon-clock"
      }[this.lastImportStatus];
    },
    alertMsg() {
      return {
        success: "finalizada com sucesso",
        fail: "falhou",
        in_progress: "em progresso"
      }[this.lastImportStatus];
    }
  },
  mounted() {
    this.$store
      .dispatch("membersStudents/lastImport", this.$route.params.id)
      .then(response => {
        this.lastImportStatus = get(response, "data.status");
      });
    this.$store.dispatch("membersGroups/getAll", {
      product_id: this.$route.params.id
    });
  },
  methods: {
    submit() {
      this.loading = true;

      this.$store
        .dispatch("membersStudents/importCSV", this.form)
        .then(() => {
          this.$message.success("Salvo com sucesso");
          this.$emit("close");
        })
        .catch(error => {
          this.errors =
            error.response.data?.message || "Erro ao importar alunos";
          this.$message.error(this.errors);
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
h5 {
  font-weight: 500;
  color: rgba(87, 88, 107, 0.88);
  margin-bottom: 0;
}
small {
  font-size: 12px;
  color: rgba(119, 120, 142, 0.87);
  line-height: 20px;
}
</style>
